import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";

export default function AddGallery() {
    const [name, setName] = useState('');
    const [category, setCategory] = useState('');
    const [date, setDate] = useState('');
    const [locationOrigin, setLocationOrigin] = useState('');
    const [locationFinish, setLocationFinish] = useState('');
    const [image, setImage] = useState(null);
    const [error, setError] = useState('');
    const history = useHistory(); // Changed to useHistory instead of navigate
    const api = "https://apibbytowing.vercel.app";

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', name);
        formData.append('category', category);
        formData.append('date', date);
        formData.append('location_origin', locationOrigin);
        formData.append('location_finish', locationFinish);
        formData.append('image', image);

        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
            alert('No token found. Please log in.');
            return;
        }

        try {
            const response = await axios.post(`${api}/api/create`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            alert(response.data.message);
            history.push('/gallery');
        } catch (error) {
            if (error.response && error.response.status === 401) {
                handleTokenRefresh();
            } else {
                setError(error.message);
            }
        }
    };

    const handleTokenRefresh = async () => {
        try {
            const refreshResponse = await axios.post(`${api}/api/refreshToken`, null, {
                withCredentials: true
            });
            const newAccessToken = refreshResponse.data.accessToken;
            localStorage.setItem('accessToken', newAccessToken);
            handleSubmit();
        } catch (refreshError) {
            alert('Failed to refresh token. Please log in again.');
            localStorage.removeItem('accessToken');
        }
    };

    const previewImage = (event) => {
        const file = event.target.files[0];
        const imagePreview = document.getElementById('image-preview');

        if (file) {
            setImage(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                imagePreview.src = e.target.result;
                imagePreview.parentElement.classList.remove('hidden');
            };
            reader.readAsDataURL(file);
        } else {
            setImage(null);
            imagePreview.src = '#';
            imagePreview.parentElement.classList.add('hidden');
        }
    };

    return (
        <div className="w-full h-full flex flex-col-reverse md:flex-row items-center justify-center gap-6 py-24">
            <div id="image-preview-container" className="hidden">
                <img id="image-preview" src="#" alt="Preview" className="max-w-full max-h-96" />
            </div>
            <div className="border p-6 rounded-xl shadow-lg w-[400px] bg-[#fcfc00c0]">
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-6">
                        {error && <p className='text-center text-red-600 mb-4'>{error}</p>}
                        <div className="w-full">
                            <input
                                type="text"
                                placeholder='Nama Kendaraan'
                                required
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-slate-50 py-2"
                            />
                        </div>
                        <div className="w-full">
                            <select
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black outline-none focus:outline-none focus:border-slate-50 py-2"
                            >
                                <option value="">Pilih Kategori</option>
                                <option value="Jasa Derek Mobil">Jasa Derek Mobil</option>
                                <option value="Jasa Derek Motor">Jasa Derek Motor</option>
                            </select>
                        </div>
                        <div className="w-full">
                            <input
                                type="date"
                                required
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-slate-50 py-2"
                            />
                        </div>
                        <div className="w-full">
                            <input
                                type="text"
                                required
                                value={locationOrigin}
                                placeholder='Keberangkatan'
                                onChange={(e) => setLocationOrigin(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-slate-50 py-2"
                            />
                        </div>
                        <div className="w-full">
                            <input
                                type="text"
                                required
                                value={locationFinish}
                                placeholder='Destinasi'
                                onChange={(e) => setLocationFinish(e.target.value)}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-slate-50 py-2"
                            />
                        </div>
                        <div className="w-full">
                            <input
                                type="file"
                                onChange={previewImage}
                                className="w-full bg-[#fcfc00c0] border-b-2 border-black focus:outline-none focus:border-slate-50 py-2"
                            />
                        </div>
                        <button
                            type='submit'
                            className="bg-black hover:bg-black flex flex-row justify-between px-4 py-3 rounded-xl shadow-md"
                        >
                            <p className="font-bold text-white">Tambahkan Menu</p>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
